﻿export default class Aside {

    asideSelector = '[data-js-aside]';
    siteHeaderSelector = '[data-js-site-header]';
    toggleButton = '[data-js-toggle-button]';
    menuContent = '[data-js-menu-content]';

    stickyClass = 'js-sticky';
    showClass = 'js-show';
    breakGridMobile = 980;

    constructor() {
        this.setup();      
    }

    setup = () => {
        const viewportSize = document.body.getBoundingClientRect().width
        const aside = document.querySelector(this.asideSelector);
      
        if(viewportSize >= this.breakGridMobile) {
            if (aside) {
                this.handleSticky(aside);
            }
        } 
        
        const button = document.querySelector(this.toggleButton);

        if (button) {
            button.addEventListener("click", (e) => {
            const content = document.querySelector(this.menuContent);
            if (content) {
                this.showMenu(content, button);
            }
            });
        }
    }


    handleSticky = (aside) => {
        const hero = document.querySelector(this.siteHeaderSelector);
        let heroHeight = hero.offsetHeight;

        window.addEventListener('scroll', () => {

            if (window.scrollY >= heroHeight) {
                aside.classList.add(this.stickyClass)

            } else {
                aside.classList.remove(this.stickyClass);
            }
        })
    }

    
    showMenu = (content, button) => {
        if(content.classList.contains(this.showClass)) {
            content.classList.remove(this.showClass)
            content.setAttribute('aria-hidden', 'true')
            button.setAttribute('aria-expanded', 'false')
            
        } else {
            content.classList.add(this.showClass)
            content.setAttribute('aria-hidden', 'false')
            button.setAttribute('aria-expanded', 'true')
        } 
    }
}




